export default function (id, bem) {
  let window = id ? `remocao.${id}` : 'remocao.new'
  let css = window.replace(/\./g, '-')
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Solicitação de Remoção' + (id ? ` #${id}` : ''),
    width: '1000',
    height: '800',
    minHeight: '500px',
    backdrop: false,
    clickOutside: false,
    maximize: false,
    move: false,
    fullscreen: true,
    disableFixedSize: true,
    windowClass: 'bem-window ' + css,
    contentClass: 'overflow-hidden',
    props: {
      id: id,
      bemProp: bem
    }
  }, () => import('../components/window/Remocao.vue'))
    .then((wid) => {
      console.log(wid)
      setTimeout(() => {
        document.querySelector('.bem-window.' + css).classList.add('opened')
      }, 20)
      this.$uloc.window.listen(wid, {
        update: (wid, val) => {
          console.log('Atualizado: ', val)
          this.updateList && this.updateList(val)
        }
      })
    }) // return wid
}
